export const LOADER_STATUS = "boilerplate/apireport/LOADER_STATUS";
export const SET_PAGE_COUNT = "boilerplate/apireport/SET_PAGE_COUNT";
export const SET_PAGE_DATA = "boilerplate/apireport/SET_PAGE_DATA";
export const SET_CURRENT_PAGE = "boilerplate/apireport/SET_CURRENT_PAGE";
